const STEPS = 4;
const SELECTOR = '.c-playlist_item';

let items = [];
let running = false;

export class PlaylistProximity {
  static init() {
    items = [...document.querySelectorAll(SELECTOR)];
    if (!items.length) return;

    running = true;
    this.loop();
  }

  static destroy() {
    running = false;
  }

  static loop() {
    if (!running) return;

    const centerY = window.innerHeight / 2;

    items.forEach(item => {
      const rect = item.getBoundingClientRect();
      const itemCenterY = rect.top + rect.height / 2;
      const distance = Math.abs(itemCenterY - centerY);
      const step = Math.floor(distance / rect.height);
      const proximity = Math.max(0, 1 - step / STEPS);

      item.style.setProperty('--proximity', proximity);
    });

    requestAnimationFrame(() => this.loop());
  }
}
